import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'
import { TextField, SelectField } from '../../components'
import { Alert, Button, Col, Row, SubmitRow } from '../../elements'
import momentTZ from 'moment-timezone';

import validate from './validate'

class SiteForm extends Component {
    static propTypes = {
        onSubmit: PropTypes.func,
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { clientId, initialValues, onSubmit } = this.props
        const editMode = Boolean(get(initialValues, 'siteId'))
        onSubmit({
            createSite: ! editMode && {
            clientId,
            siteId,
            description,
            address,
            timeZone }
        //   editHolder: editMode && {
        //     clientId,
        //     clientReference,
        //     holderType,
        //     changes: {
        //       name: holderBuffer.name,
        //       note: holderBuffer.note,
        //       active: holderBuffer.active,
        //       image: holderBuffer.image && holderBuffer.image.data,
        //       metadata: holderBuffer.metadata } }
        })
      }

    render() {
        const { isSubmiting, handleSubmit, onSubmit, clients, initialValues } = this.props
        const clientIdDisabled = Boolean(get(initialValues, 'clientId'))
        const siteIdDisabled = Boolean(get(initialValues, 'siteId'))
        const timeZonesList = momentTZ.tz.names();
        let clientIds = null
        if(clients){
            clientIds = clients.map(client => client.clientId);
        } else if (initialValues) {
            clientIds = [initialValues.clientId]
        }

        if(clientIds == null){
            clientIds = ['']
        }

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Field
                    name="clientId"
                    label="Client Id"
                    options={clientIds}
                    disabled={isSubmiting}
                    component={SelectField}
                    disabled={clientIdDisabled}
                />
                <Field
                    name="siteId"
                    label="Site Id"
                    disabled={isSubmiting}
                    component={TextField}
                    disabled={siteIdDisabled}
                />
                <Field
                    name="description"
                    label="Description"
                    disabled={isSubmiting}
                    component={TextField}
                />
                <Field
                    name="address"
                    label="Address"
                    disabled={isSubmiting}
                    component={TextField}
                />
                <Field
                    name="timeZone"
                    label="Time Zone"
                    options={timeZonesList}
                    disabled={isSubmiting}
                    component={SelectField}
                />
                <Field
                    name="liveVisitGracePeriod"
                    label="Live Visit Grace Period"
                    disabled={isSubmiting}
                    component={TextField}
                    className="field"
                />
                <SubmitRow>
                    <Row type="flex" gutter={20}>
                        <Col>
                            <Button htmlType="submit" type="primary" wide>
                                {siteIdDisabled ? 'Save' : 'Create'}
                            </Button>
                        </Col>
                    </Row>
                </SubmitRow>
            </form>
        )
    }
}

export default reduxForm({
    form: 'site-form',
    validate,
})(SiteForm)



// WEBPACK FOOTER //
// ./src/smart-components/site-form/index.js